export const LENDING_AUTH_MODE_HEADER = "X-Lending-Auth-Mode";

// Django's CSRF cookie, which SessionAuthentication checks on unsafe methods. Not
// HttpOnly, so a same-origin SPA can read it and echo it back in X-CSRFToken.
export function getDigitalBankingCsrfToken(): string {
  const match = /(?:^|;\s*)csrftoken=([^;]*)/.exec(document.cookie);
  return match?.[1] ? decodeURIComponent(match[1]) : "";
}
